/**
 * Fast Check of whether a string is a valid UUID e.g. 00000000-0000-0000-0000-000000000000
 * @param str The string to check
 * @returns True if the string is a valid UUID, false otherwise
 */
export function isUUID(str?: string) {
    if (!str) return false;
    if (str.length !== 36) return false;
    return str.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)
}